var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.083,
    height: 15.534,
    viewBox: "0 0 17.083 15.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-user-guide",
    d: "M16.79,21.42A7.74,7.74,0,0,0,8.541,21.2a7.74,7.74,0,0,0-8.249.224A.657.657,0,0,0,0,21.966v13.02a.657.657,0,0,0,1.022.547,6.433,6.433,0,0,1,7.155,0c.009.006.018.007.027.012s.018.014.028.02a.692.692,0,0,0,.07.026.583.583,0,0,0,.074.028.7.7,0,0,0,.11.016c.019,0,.037.008.056.008h.016a.591.591,0,0,0,.066-.009.644.644,0,0,0,.1-.018.627.627,0,0,0,.066-.026c.02-.009.042-.013.062-.024s.016-.013.026-.019.02-.008.029-.014a6.433,6.433,0,0,1,7.155,0,.657.657,0,0,0,1.024-.549V21.966A.657.657,0,0,0,16.79,21.42ZM7.884,33.864a7.739,7.739,0,0,0-6.57,0V22.329a6.432,6.432,0,0,1,6.57,0Zm7.884,0a7.739,7.739,0,0,0-6.57,0V22.329a6.432,6.432,0,0,1,6.57,0Z",
    transform: "translate(0 -20.114)",
    fill: "#45338c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGuide);
export default __webpack_public_path__ + "static/media/icon-user-guide.cbde489ca2acbea4689698b0dd591d22.svg";
export { ForwardRef as ReactComponent };